export enum CustomerHealthDataType {
  Day = 0,
  Hour = 1,
  Count = 2,
  CountExceeds = 3
}

export interface CustomerHealthCondition {
  dataType: CustomerHealthDataType;
  dataValue: number;
  dataWeight: number;
  description: string;
}

export interface CustomerHealthModule {
  moduleName: string;
  conditions: Array<CustomerHealthCondition>;
}
  
export interface CustomerHealth {
  key: string;
  numCases: number;
  isEnable: boolean;
  modules: Array<CustomerHealthModule>;
}

export class CustomerHealthModuleIndex {
  static readonly Sales =  0;
  static readonly CustomerService =  1;
}

export class CustomerHealthConditionIndex {
  static readonly LastContactedDate =  0;
  static readonly OpenCases =  0;
  static readonly CasesCreatedLastMonth =  1;
  static readonly CaseAge =  2;
  static readonly LastSupportContact =  3;
}

export class CustomerHealthComparer {
  
  static areEqual(originalObj?: CustomerHealth, changedObj?: CustomerHealth): boolean {
    if (originalObj && changedObj) {
      const oSale = originalObj.modules[CustomerHealthModuleIndex.Sales];
      const oSaleRow0 = oSale.conditions[CustomerHealthConditionIndex.LastContactedDate];
      const oCustomerService = originalObj.modules[CustomerHealthModuleIndex.CustomerService];
      const oCustomerServiceRow0 = oCustomerService.conditions[CustomerHealthConditionIndex.OpenCases];
      const oCustomerServiceRow1 = oCustomerService.conditions[CustomerHealthConditionIndex.CasesCreatedLastMonth];
      const oCustomerServiceRow2 = oCustomerService.conditions[CustomerHealthConditionIndex.CaseAge];
      const oCustomerServiceRow3 = oCustomerService.conditions[CustomerHealthConditionIndex.LastSupportContact];
  
      const chgSale = changedObj.modules[CustomerHealthModuleIndex.Sales];
      const chgSaleRow0 = chgSale.conditions[CustomerHealthConditionIndex.LastContactedDate];
      const chgCustomerService = changedObj.modules[CustomerHealthModuleIndex.CustomerService];
      const chgCustomerServiceRow0 = chgCustomerService.conditions[CustomerHealthConditionIndex.OpenCases];
      const chgCustomerServiceRow1 = chgCustomerService.conditions[CustomerHealthConditionIndex.CasesCreatedLastMonth];
      const chgCustomerServiceRow2 = chgCustomerService.conditions[CustomerHealthConditionIndex.CaseAge];
      const chgCustomerServiceRow3 = chgCustomerService.conditions[CustomerHealthConditionIndex.LastSupportContact];
  
      if (
        oSaleRow0.dataValue !== chgSaleRow0.dataValue || oSaleRow0.dataWeight !== chgSaleRow0.dataWeight ||
        oCustomerServiceRow0.dataValue !== chgCustomerServiceRow0.dataValue || oCustomerServiceRow0.dataWeight !== chgCustomerServiceRow0.dataWeight ||
        oCustomerServiceRow1.dataValue !== chgCustomerServiceRow1.dataValue || oCustomerServiceRow1.dataWeight !== chgCustomerServiceRow1.dataWeight ||
        oCustomerServiceRow2.dataValue !== chgCustomerServiceRow2.dataValue || oCustomerServiceRow2.dataWeight !== chgCustomerServiceRow2.dataWeight ||
        oCustomerServiceRow3.dataValue !== chgCustomerServiceRow3.dataValue || oCustomerServiceRow3.dataWeight !== chgCustomerServiceRow3.dataWeight
      ) {
        return true;
      }
    }

    return false;
  }
}
